import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/cars/[slug]/specifications/SpecsFeatures.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/Button/index.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/atoms/ImageResponsive/index.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/Link/index.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/LoaderSpinner/LoaderSpinner.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/LoadingSkeleton/LoadingSkeleton.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/PageTracker/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/atoms/ReadMoreText/ReadMoreText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/atoms/Tooltip/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CarCard"] */ "/usr/src/app/src/components/molecules/CarCard/index.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/CarComparisonDesktopTable/CarComparisonDesktopTable.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/CarComparisonTable/CarComparisonTable.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/NumberBox/NumberBox.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/Badge/Badge.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/HorizontalDivider/HorizontalDivider.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/SpecsAndFeatureCard/SpecsAndFeatureCard.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/atoms/Rating/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/AvaliableColorsStack/AvailableColorsStack.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/Carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/molecules/ChatbotSupport/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/molecules/ExpandableSection/index.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/FAQItem/FAQItem.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureCard"] */ "/usr/src/app/src/components/molecules/FeatureCard/index.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/UnavailableCarBanner/UnavailableCarBanner.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/StepCard/StepCard.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/organisms/AckoDriveSteps/AckoDriveSteps.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/NCAPRating/NCAPRating.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/organisms/AckoDriveSteps/AckoDriveStepsClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AllFeaturesCarouselClient"] */ "/usr/src/app/src/components/organisms/AllFeaturesCarousel/AllFeaturesCarouselClient.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/organisms/CarComparison/CarComparison.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/organisms/CarComparison/CarComparisonMobileClient.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/organisms/CarouselSection/CarouselSection.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/organisms/FAQSection/FAQSection.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/organisms/SpecificationsSection/SpecificationSection.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/organisms/SFContentBlock/SFContentBlock.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/organisms/SpecificationsSection/SpecificationsSectionClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/organisms/SpecsPageContentBlock/SpecsPageContentBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/organisms/StandoutFeatures/StandoutFeature.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["getClientCookie"] */ "/usr/src/app/src/lib/cookies.client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["getAppOsFromPlatformValue"] */ "/usr/src/app/src/utils/platformDetection.client.ts");
